/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-spread */
/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import globalApps, { init } from '@bingads-webui-clientcenter/global-apps';
import config from '@bingads-webui-clientcenter/config';
import logging from 'instrumentation/log';
import perfApi from 'instrumentation/performance-api';
import pageContext from 'PageContext';
import instrumentation from 'instrumentation/instrumentation';
import i18n from 'core/i18n';
import $ from 'jquery';

const batchSize = 25;
const uploadInterval = 10000;

export const initGlobalApps = ({
  initNonSpaAlertCenter = false,
} = {}) => {
  const globalAppsOptions = {
    pageContext,
    instrumentation: { logging, perfApi },
    config,
  };

  if (initNonSpaAlertCenter) {
    const { globalAppsProps: { i18nStrings } } = window._webpack_init_props;
    i18n.define(i18nStrings);
    globalAppsOptions.i18n = i18n;
  }

  init(globalAppsOptions);

  perfApi.mark('GlobalApps_initialized');

  if (pageContext.scenarioName) {
    instrumentation.start(
      batchSize,
      uploadInterval,
      pageContext.sessionCookieName,
      pageContext.scenarioName
    );
  }

  if (initNonSpaAlertCenter) {
    const { globalAppsProps: { aggregatedAlert } } = window._webpack_init_props;

    $('#carousel-banner').append(globalApps.staticAlertCenter.render().el);

    const alert = aggregatedAlert;
    if (alert) {
      if (alert.actionTriggered) {
        globalApps.alertCenter.show(alert);
      } else {
        globalApps.staticAlertCenter.show(alert);
      }
    }
  }

  if (window._webpack_init_props.globalAppsProps) {
    delete window._webpack_init_props.globalAppsProps;
  }
};
